<div class="component-container power-connection-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-section-header
      [title]="'technician-data.power-connection-title' | translate"
      [tooltip]="'tooltips.technician-form.power-connection' | translate"
      [showTooltip]="infoBubblesData?.showPowerSupplyInfo"></app-section-header>
  </div>

  <form [formGroup]="powerConnectionFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div class="form-background">
      <div class="ui-g-12 form-rows">
        <div class="ui-g-6 field-rows" *ngIf="powerConnectionFG.get('totalOutput')">
          <label
            for="power-connection-total-output"
            class="ui-g-5 field-label text-right-align"
            [class.required]="isFieldRequired('totalOutput')">
            {{
              (showConnectedLoadLabel ? 'technician-data.form-fields.connected-load' : 'technician-data.form-fields.total-output')
                | translate
            }}
          </label>
          <input
            [appNumber]="true"
            class="ui-input pInputText small-width"
            formControlName="totalOutput"
            id="power-connection-total-output"
            maxlength="5"
            pInputText
            size="30"
            [readonly]="isReadOnly" />
          <span class="field-unit-label">{{ unitLabels.power }}</span>
        </div>
        <div class="ui-g-6 field-rows" *ngIf="powerConnectionFG.get('requiredFusePower')">
          <label class="ui-g-5 field-label text-right-align required" for="power-connection-fuse-power">
            {{ 'technician-data.form-fields.swkn-required-fuse-power' | translate }}
          </label>
          <p-dropdown
            [options]="requiredFusePowerTypes"
            [readonly]="isReadOnly"
            formControlName="requiredFusePower"
            id="power-connection-fuse-power"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">
                {{ 'lookup.' + requiredFusePowerTypeKey + '.options.' + item['value'] + '.name' | translate }}
              </span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + requiredFusePowerTypeKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="ui-g-6 field-rows padding-left-1" *ngIf="showStandardPowerWarning || showInfoForCommodities">
          <span [innerHTML]="'technician-data.standard-power-warning' | translate"></span>
        </div>
      </div>
      <div *ngIf="powerConnectionFG.get('craneAvailable')" class="ui-g-12 form-rows">
        <div class="ui-g-6 field-rows">
          <label class="ui-g-5 field-label text-right-align required mr-3">
            {{ 'technician-data.form-fields.crane-available' | translate }}
          </label>
          <span class="ui-g-3 available-radio-buttons">
            <p-radioButton
              formControlName="craneAvailable"
              label="{{ 'yes-button-label' | translate }}"
              name="craneAvailable"
              [value]="true"></p-radioButton>
            <p-radioButton
              formControlName="craneAvailable"
              label="{{ 'no-button-label' | translate }}"
              name="craneAvailable"
              [value]="false"></p-radioButton>
          </span>
        </div>
      </div>

      <div *ngIf="powerConnectionFG.get('pumpAvailable')" class="ui-g-12 form-rows">
        <div class="ui-g-6 field-rows">
          <label class="ui-g-5 field-label text-right-align required mr-3">
            {{ 'technician-data.form-fields.pump-available' | translate }}
          </label>
          <span class="ui-g-3 available-radio-buttons">
            <p-radioButton
              formControlName="pumpAvailable"
              label="{{ 'yes-button-label' | translate }}"
              name="pumpAvailable"
              [value]="true"></p-radioButton>
            <p-radioButton
              formControlName="pumpAvailable"
              label="{{ 'no-button-label' | translate }}"
              name="pumpAvailable"
              [value]="false"></p-radioButton>
          </span>
        </div>
      </div>

      <div>
        <ng-container *ngFor="let value of specialDeviceCount">
          <app-special-consumers
            (deleteComponent)="removeChildElements($event)"
            [isReadOnly]="isReadOnly"
            [specialDeviceData]="specialDeviceData[value]"></app-special-consumers>
        </ng-container>
        <div class="ui-g-12 add-button-row" *ngIf="!isReadOnly && showAddPowerDeviceButton">
          <div class="empty-container"></div>
          <i (click)="addSpecialDevice()" class="pi pi-plus plus-icon" id="power-connection-add-consumer"></i>
          <label class="ui-g-5 field-label" for="power-connection-add-consumer">
            {{ 'technician-data.form-fields.special-consumers-button' | translate }}
          </label>
        </div>
      </div>
    </div>
  </form>
</div>
